import { gql } from "@apollo/client";

export const UPSERT_FLOORPLAN = gql`
  mutation UpsertFloorPlan($input: FloorPlanInput!) {
    upsertFloorPlan(input: $input) {
        floorPlanData,
        customerPlanData,
        enabledCustomerPlan
    }
  }
`;
